import { create } from "zustand";

import { STRINGS } from "../utils/strings";

const initialState = {
  currentPage: STRINGS.DEFAULT_PAGE,
  data: [],
  loading: false,
  resLimit: STRINGS.DEFAULT_PAGINATION_LIMIT,
  resultCount: 0,
};

export const useEntityUsersStore = create((set) => ({
  ...initialState,
  reset: () => set(initialState),
  setCurrentPage: (currentPage) => set({ currentPage }),
  setData: (data) => set({ data }),
  setLoading: (loading) => set({ loading }),
  setResultCount: (resultCount) => set({ resultCount }),
}));
